import { AppSettings } from 'app/app.settings';
import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-request.service";
import * as i2 from "./user.service";
var BookmarkService = /** @class */ (function () {
    function BookmarkService(requestService, userService) {
        this.requestService = requestService;
        this.userService = userService;
        this.bookmarkVisibilities = [{
                label: 'Personal',
                value: 'Personal'
            }, {
                label: 'Agency',
                value: 'Agency'
            }, {
                label: 'State',
                value: 'State'
            }];
    }
    BookmarkService.prototype.getMapBookmarks = function (type) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/bookmarks';
            _this.requestService.requestGet(url, {
                params: {
                    userId: _this.userService.getUserInfo().userId,
                    application: AppSettings.appName,
                    type: type
                }
            }, function (rsp) {
                var bookmarkList = [];
                if (rsp.data) {
                    // if (type === 'HREF') {
                    // 	rsp.data = [
                    // 		{
                    // 			"bkm_id": 27,
                    // 			"bkm_mod_cd": "AZGIV",
                    // 			"bkm_name": "NG911 GIS Data Model",
                    // 			"bkm_description": "NENA Standards - NG911 GIS Data Model",
                    // 			"usr_id": 0,
                    // 			"usr_name": "admin",
                    // 			"usr_cus_id": 0,
                    // 			"bkm_visibility": "System",
                    // 			"bkm_type": "HREF",
                    // 			"bkm_bbox": null,
                    // 			"bkm_href": "https://cdn.ymaws.com/www.nena.org/resource/resmgr/standards/nena-sta-006.2a_ng9-1-1_gis_.pdf"
                    // 		},
                    // 		{
                    // 			"bkm_id": 28,
                    // 			"bkm_mod_cd": "AZGIV",
                    // 			"bkm_name": "USPS Pub 28 - Addressing Standards",
                    // 			"bkm_description": "USPS Pub 28 - Addressing Standards",
                    // 			"usr_id": 0,
                    // 			"usr_name": "admin",
                    // 			"usr_cus_id": 0,
                    // 			"bkm_visibility": "System",
                    // 			"bkm_type": "HREF",
                    // 			"bkm_bbox": null,
                    // 			"bkm_href": "https://pe.usps.com/text/pub28/welcome.htm"
                    // 		}
                    // 	]
                    // }
                    rsp.data.forEach(function (d) {
                        var bm = {
                            id: d.bkm_id,
                            name: d.bkm_name,
                            desc: d.bkm_description,
                            module: d.knm_mod_cd,
                            visibility: d.bkm_visibility,
                            type: d.bkm_type,
                            bbox: d.bkm_bbox,
                            href: d.bkm_href,
                            userId: d.usr_id,
                            userName: d.usr_name,
                            cusId: d.usr_cus_id,
                            ownerDisplay: d.usr_name.split('@')[0]
                        };
                        bookmarkList.push(bm);
                    });
                }
                resolve(bookmarkList);
            }, function (err) {
                reject(err);
            });
        });
    };
    BookmarkService.prototype.addMapBookmarks = function (name, desc, visib, type, bbox, href) {
        var _this = this;
        var url = AppSettings.serviceRootUrl + 'admin/bookmarks';
        return new Promise(function (resolve, reject) {
            var body = {
                name: name,
                description: desc,
                visibility: visib,
                type: type,
                userId: _this.userService.getUserInfo().userId,
                application: AppSettings.appName
            };
            if (type === 'HREF') {
                body.href = href;
            }
            else {
                body.bbox = JSON.stringify(bbox);
            }
            _this.requestService.requestPost(url, body, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    BookmarkService.prototype.deleteMapBookmark = function (id) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'admin/bookmarks';
            var body = {
                id: id
            };
            _this.requestService.requestDelete(url, {
                body: body
            }, function () { return resolve(); }, function (err) { return reject(err); });
        });
    };
    BookmarkService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BookmarkService_Factory() { return new BookmarkService(i0.ɵɵinject(i1.CommonRequestService), i0.ɵɵinject(i2.UserService)); }, token: BookmarkService, providedIn: "root" });
    return BookmarkService;
}());
export { BookmarkService };
